module.exports = __webpack_public_path__ + "img/maj2.c5472cea.jpg";